<div class="flight-details__wrapper" [ngClass]="{'condensed': summaryMode}">
	
	<div class="flight-details__logo" 
		[tooltip]="isMobile ? '' : airlineName"
		[attr.aria-label]="isMobile ? '' : INDRA_getTranslationAsync('bookingDetails.aria.flightOperatedBy') | async"
		*ngIf="!hideLogo">
		<app-svg  
			[svg]="airlineLogo"
			[tooltip]="airlineName"
			[alt]="airlineName" 
			[classes]="'logo'">
		</app-svg>
	</div>
	
	<div class="flight-details__route" [attr.aria-label]="ariaLabelRoute">
		<div class="flight-details__time-location is-departure" aria-hidden="true">
			<p class="bold">
				{{INDRA_printDepartureTime()}}
			</p>
			<p class="muted" tooltip="{{ isMobile ? '' : departureAirportName }}">
				{{INDRA_getDepartureAirport()}}
			</p>
		</div>
		<div class="flight-details__arrow" aria-hidden="true">
			<app-arrow [legs]="INDRA_printLegStops()" [stops]="INDRA_getStops()" [commercialStops]="INDRA_getCommercialStops()" [allStops]="INDRA_getAllStops()"></app-arrow>
		</div>
		<div class="flight-details__time-location is-arrival" aria-hidden="true">
			<p class="bold">
				{{INDRA_printArrivalTime()}} 
				<span *ngIf='INDRA_isOnAnotherDay()' class='flight__extra-time'>
					+{{INDRA_printFlightDays()}}
				</span>
			</p>
			<p class="muted" tooltip="{{ isMobile ? '' : arrivalAirportName }}">
				{{INDRA_getArrivalAirport()}}
			</p>
		</div>
	</div>
	<div *ngIf="!summaryMode" 
		class="flight-details__duration-connections" 
		[attr.aria-label]="isMobile ? '' : ariaLabelDurationStops">
		<p aria-hidden="true">
			{{ INDRA_printDuration() }}
		</p>
		<p aria-hidden="true" class="muted">
			<span skeletonLoader [translationKey]="INDRA_printStopsCountUnitKey()">
				<span *ngIf="INDRA_printStopsCount() > 0">
					{{ INDRA_printStopsCount() }} 
				</span>

				{{ INDRA_printStopsCountUnitKey() | ibeadmin | async }}
			</span>
		</p>
	</div>
	<div class="flight-details__number-details" *ngIf="!summaryMode">
		<p [attr.aria-label]="isMobile ? '' : INDRA_ariaLabelNumberDetails()">
			<span *ngIf="INDRA_getFlightNumberLength() > 1" skeletonLoader [translationKey]="'bookingDetails.text.flights'">
				{{ INDRA_getFlightNumberLength() }} {{'bookingDetails.text.flights' | ibeadmin | async}}
			</span>
			<span *ngIf="INDRA_getFlightNumberLength() === 1">
				{{ flightNumber }}
			</span>
		</p>
		<p [attr.aria-label]="isMobile ? '' : INDRA_ariaLabelOpenDialog()" class="muted">
			<a class="link" (click)="INDRA_handleDetailsClick()" skeletonLoader [translationKey]="'bookingDetails.link.details'">
				{{'bookingDetails.link.details' | ibeadmin | async}}
			</a>
		</p>
	</div>
	<div class="flight-details__duration-details" *ngIf="!summaryMode">
		<p [attr.aria-label]="isMobile ? '' : ariaLabelDurationStops">
			{{INDRA_printDuration()}}
		</p>
		<p [attr.aria-label]="isMobile ? '' : INDRA_ariaLabelDurationDetails()" class="muted">
			<a *ngIf="INDRA_getFlightNumberLength() === 1" class="link" (click)="INDRA_handleDetailsClick()">
				{{ flightNumber }}
			</a>
			<a *ngIf="INDRA_getFlightNumberLength() > 1" class="link" (click)="INDRA_handleDetailsClick()">
				{{ INDRA_getFlightNumberLength() }} {{INDRA_getTranslationAsync('bookingDetails.text.flights') | async}}
			</a>
		</p>
	</div>
</div>
<div class="flight-airplane__wrapper flight-airplane__wrapper__row"
	*ngIf="(operatedBy || INDRA_printAirplaneLogo()) && showAirplane">
	<app-svg 
		*ngIf="INDRA_printAirplaneLogo()" 
		[svg]='INDRA_printAirplaneLogo()' 
		[alt]='INDRA_printAirplaneLabel()'
		class="airplane" 
		[classes]="'airplane--icon airplane--icon-' + INDRA_getAirplaneLogo()">
	</app-svg>
	<p *ngIf="operatedBy" class="operated-by">
		<span skeletonLoader [translationKey]="'availability.flightsPage.text.operatedBy'">
			{{'availability.flightsPage.text.operatedBy' | ibeadmin |async}} {{ INDRA_print(operatedBy) }}
		</span>
	</p>
</div>
<div class="flight-airplane__wrapper flight-airplane__wrapper__row">
	<span *ngIf="INDRA_showInfo()" class="flight-note italic">
		<app-svg 
			class="flight-note__icon" 
			svg="icons.svg#general--information" 
			alt="Information icon" 
			aria-hidden="true">
		</app-svg> 
		<span skeletonLoader [translationKey]="'bookingDetails.text.subjectToApproval'">
			{{'bookingDetails.text.subjectToApproval' | ibeadmin | async}}
		</span>
		<a class="link padding-left-gap" 
			href="javascript:;"
			(click)="INDRA_gotoURL('externalURLs.subjectToApproval')"
			role="button" 
			attr.aria-label="{{INDRA_getTranslationAsync('bookingDetails.label.governmentApproval') | async}}" 
			aria-hidden="true"
			[tooltip]="isMobile? '' : INDRA_getTranslationAsync('bookingDetails.alt.tapGuaranteeFlight') | async"
		>
			<span skeletonLoader [translationKey]="'bookingDetails.text.learnMore'">
				{{'bookingDetails.text.learnMore' | ibeadmin | async}}
			</span>
		</a>
	</span>
	<span *ngIf="INDRA_promoNotAvailable()" class="flight-note italic">
		<app-svg 
			class="flight-note__icon" 
			svg="icons.svg#general--information" 
			alt="Information icon" 
			aria-hidden="true">
		</app-svg>
		<span skeletonLoader [translationKey]="'bookingDetails.text.notSubjectToDiscount'">
			{{'bookingDetails.text.notSubjectToDiscount' | ibeadmin | async}}
		</span>
	</span>
</div>
